module.exports = {"dateTimePickerFormat":{"year":"numeric","month":"numeric","day":"numeric","hour":"numeric","minute":"2-digit"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurations/configurations.json
// module id = 3xB6
// module chunks = 53